import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonText, IonTitle, IonToolbar, useIonViewDidEnter } from "@ionic/react";
import { useLocation } from "react-router";


const DirectDonate: React.FC = () => {

    const name='Credit Your account';

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>{name}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonText>
                    <h1>Payment details</h1>
                    <p>add meta to say direct payment</p>
                </IonText>
            </IonContent>
        </IonPage>
    );
}

export default DirectDonate;